import React, { useState } from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import "./viewContact.scss";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import {
  EmailNotVerified,
  EmailVerified,
  VerificationSentButton,
  VerifyEmailButton,
} from "../../../../library/custom/emailVerification/emailStatus";

const ViewContact = ({
  viewContactData,
  dataBack,
  sendEmailVerification,
  contactId,
}) => {
  const data = viewContactData?.result;

  console.log("contactId", contactId);

  const [isVerificationSent, setIsVerificationSent] = useState(false);

  const handleVerifyClick = () => {
    const EMAIL_TYPE_FOR_CONTACT = 2;
    const data = {
      id: contactId,
      type: EMAIL_TYPE_FOR_CONTACT,
    };
    sendEmailVerification(data);
    setIsVerificationSent(true);
  };

  return (
    <div className="viewOverideContact">
      <BackBtn dataBack={dataBack} />
      <div className="commonOveride">
        <Box>
          <Typography className="titleDetail">
            {data?.firstName} {data?.lastName}
          </Typography>
        </Box>
        <Box className="commoninfoWrap">
          <Box className="commoninfoBox">
            <Box className="commoninfoleft">
              <Typography className="title">Personnel information:</Typography>

              <Box className="columns">
                <Typography className="listView">
                  Company Name:
                  <span className="focusedText">{data?.companyName}</span>
                </Typography>
                <Typography className="listView">
                  Job Title:
                  <span className="focusedText">{data?.designation}</span>
                </Typography>
              </Box>
              <Box className="columns">
                <Typography className="listView">
                  Phone Number:
                  <span className="font-w400">{data?.phone}</span>
                </Typography>
              </Box>
              <Box
                className="columns"
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#333",
                  whiteSpace: "nowrap",
                  gap: "35px",
                }}
              >
                <Typography className="listView">
                  Email ID:
                  <span
                    className="font-w400"
                    style={{
                      maxWidth: "300px",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {data?.email}
                  </span>
                </Typography>

                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "10px",
                    flexGrow: 1,
                    whiteSpace: "nowrap",
                    position: "relative",
                    bottom: "12px",
                  }}
                >
                  {data?.isEmailVerified ? (
                    <EmailVerified />
                  ) : (
                    <>
                      <EmailNotVerified />
                      {!isVerificationSent ? (
                        <VerifyEmailButton onClick={handleVerifyClick} />
                      ) : (
                        <VerificationSentButton />
                      )}
                    </>
                  )}
                </Box>
              </Box>
              <Box className="columns">
                <Typography className="listView">
                  Address1:
                  <span className="font-w400">{data?.address1}</span>
                </Typography>
                <Typography className="listView">
                  Address2:
                  <span className="font-w400">{data?.address2}</span>
                </Typography>
              </Box>
              <Box className="columns">
                <Typography className="listView">
                  State:
                  <span className="font-w400">{data?.stateName}</span>
                </Typography>
                <Typography className="listView">
                  City:
                  <span className="font-w400">{data?.cityName}</span>
                </Typography>
              </Box>
              <Box className="columns">
                <Typography className="listView">
                  Office Number:
                  <span className="font-w400">{data?.officePhone}</span>
                </Typography>
                <Typography className="listView">
                  Zip Code:
                  <span className="font-w400">{data?.zipCode}</span>
                </Typography>
              </Box>
              <Box className="columns">
                <Typography className="listView ">
                  Service Type:
                  {data?.product?.map((item) => (
                    <span className="font-w400" key={item?.key}>
                      {item?.value}
                    </span>
                  ))}
                </Typography>
                {data?.certificationNumber && (
                  <Typography className="listView">
                    Certification Number:
                    <span className="font-w400">
                      {data?.certificationNumber}
                    </span>
                  </Typography>
                )}
              </Box>
              <Box className="columns">
                <Typography className="listView desNone">
                  Notes:
                  <span className="font-w400">{data?.notes}</span>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default ViewContact;
